module.exports = __webpack_public_path__ + "img/save_recovery_reset.ffaab876.png";